import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  state: {
    applications: [],
    applicationsLoading: false,
  },
  mutations: {
    setApplications(state, applications) {
      state.applications = applications;
    },
    setApplicationsLoading(state, loading) {
      state.applicationsLoading = loading;
    },
  },
  actions: {
    async loadApplications({ commit }) {
      commit("setApplicationsLoading", true);
      let applications = await api.get("applications");
      commit("setApplications", applications.data);
      commit("setApplicationsLoading", false);
    },
    async newApplication({ commit, dispatch }, payload) {
      await api.post("applications", payload);
      dispatch("loadApplications");
    },
    async saveApplication({ commit, dispatch }, payload) {
      await api.put("applications", payload);
      dispatch("loadApplications");
    },
  },
  getters: {
    applicationsLoading(state) {
      return state.applicationsLoading;
    },
    applications(state) {
      return state.applications;
    },
  },
};
